import { render, staticRenderFns } from "./report-face15.vue?vue&type=template&id=1c21fa4a&scoped=true&"
import script from "./report-face15.vue?vue&type=script&lang=ts&"
export * from "./report-face15.vue?vue&type=script&lang=ts&"
import style0 from "./report-face15.vue?vue&type=style&index=0&id=1c21fa4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21fa4a",
  null
  
)

export default component.exports